import { Box, Carousel } from '@hermes/web-components'
import ReviewCard from '../ReviewCard'
import { Section } from '../styles'
import { FC, useContext } from 'react'
import { StyledSplideSlide } from './styles'
import { TransformHomePageReviews } from '../../../types/homePage'
import { AppDataContext } from '../../../providers/AppData'
import getDomainName from '../../../utils/getDomainName'
import { purifyTenantDomain } from '../../../utils/url'

interface Props {
  reviews?: TransformHomePageReviews[]
}

const ReviewsSection: FC<Props> = ({ reviews }) => {
  const { locale } = useContext(AppDataContext)
  const domainName = getDomainName()
  const originWithLang = purifyTenantDomain(domainName, locale)

  const hrefBuilder = (type: string, slug: string) => `${originWithLang}/${type}/${slug}`

  return (
    <Section>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '48px', md: '32px' } }}>
        <Carousel
          navigationPosition="bottom"
          options={{
            autoplay: true,
            rewind: true,
            interval: 4000,
            autoScroll: {
              pauseOnHover: true,
              pauseOnFocus: true
            }
          }}
          breakpoints={{ 768: { perPage: 1 }, 1024: { perPage: 2 } }}
          spaceBetween={24}
          navButtonStyles={{
            background: 'none',
            svg: { width: '16px', height: '16px' },
            width: '40px',
            height: '40px',
            'svg > path': { fill: '#11245A' }
          }}
          navigation
          slidesPerView={3}
          lazyLoad={true}
        >
          {reviews?.map((item) => (
            <StyledSplideSlide key={item.id}>
              <ReviewCard {...item} hrefToRedirect={hrefBuilder(item.type, item.slug)} />
            </StyledSplideSlide>
          ))}
        </Carousel>
      </Box>
    </Section>
  )
}

export default ReviewsSection
